import { Navigate } from 'react-router-dom'

// Guards the widget admin sub-app. The token is stored in sessionStorage by
// WidgetAdminLogin after a successful password check.
export default function WidgetAdminGuard({ children }) {
  const token = sessionStorage.getItem('tredex_widget_token')
  if (!token) return <Navigate to="/admin/widget/login" replace />
  return children
}
